import { DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, inject, Injectable, Directive, Inject, Input } from '@angular/core';
import { $append } from '@js-dot/ui';
import { DotComponentService } from '@ng-dot/core';
class DotRippleStyleComponent {
  static ɵfac = function DotRippleStyleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotRippleStyleComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotRippleStyleComponent,
    selectors: [["dot-ripple-style"]],
    decls: 0,
    vars: 0,
    template: function DotRippleStyleComponent_Template(rf, ctx) {},
    styles: [":root{--ripple: rgba(127, 127, 127, .16)}.dot-ripple{position:relative}.dot-ripple-area,.dot-ripple-reposition{display:block!important;padding:0!important}.dot-ripple-area{position:absolute;inset:0;overflow:hidden;border-radius:inherit}.dot-ripple-reposition{position:relative;height:100%}.dot-ripple-instance,.dot-ripple:before{content:\"\";display:block;position:absolute;width:200%;height:0;padding-bottom:200%;top:50%;left:50%;border-radius:50%;background-color:var(--ripple);z-index:-1;transform:translate(-50%,-50%);animation:BE4PlkpQ2hSJV5DIZFW8Hhdj7JvOS3Ln .72s both ease-out}@keyframes BE4PlkpQ2hSJV5DIZFW8Hhdj7JvOS3Ln{0%{transform:translate(-50%,-50%) scale(0)}35%{opacity:1}67%{opacity:1;transform:translate(-50%,-50%) scale(1)}to{opacity:0}}.dot-ripple:before{display:none}.dot-ripple:focus:before{display:block}.dot-ripple_js:before{display:none!important;animation:none}.dot-ripple._main{--ripple: var(--m16a)}.dot-ripple._sub{--ripple: var(--s16a)}.dot-ripple._point{--ripple: var(--p16a)}.dot-ripple._warn{--ripple: var(--w16a)}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotRippleStyleComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'dot-ripple-style',
      template: ``,
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      styles: [":root{--ripple: rgba(127, 127, 127, .16)}.dot-ripple{position:relative}.dot-ripple-area,.dot-ripple-reposition{display:block!important;padding:0!important}.dot-ripple-area{position:absolute;inset:0;overflow:hidden;border-radius:inherit}.dot-ripple-reposition{position:relative;height:100%}.dot-ripple-instance,.dot-ripple:before{content:\"\";display:block;position:absolute;width:200%;height:0;padding-bottom:200%;top:50%;left:50%;border-radius:50%;background-color:var(--ripple);z-index:-1;transform:translate(-50%,-50%);animation:BE4PlkpQ2hSJV5DIZFW8Hhdj7JvOS3Ln .72s both ease-out}@keyframes BE4PlkpQ2hSJV5DIZFW8Hhdj7JvOS3Ln{0%{transform:translate(-50%,-50%) scale(0)}35%{opacity:1}67%{opacity:1;transform:translate(-50%,-50%) scale(1)}to{opacity:0}}.dot-ripple:before{display:none}.dot-ripple:focus:before{display:block}.dot-ripple_js:before{display:none!important;animation:none}.dot-ripple._main{--ripple: var(--m16a)}.dot-ripple._sub{--ripple: var(--s16a)}.dot-ripple._point{--ripple: var(--p16a)}.dot-ripple._warn{--ripple: var(--w16a)}\n"]
    }]
  }], null, null);
})();
class DotRippleStyleService {
  constructor() {
    inject(DotComponentService).append(DotRippleStyleComponent);
  }
  static ɵfac = function DotRippleStyleService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotRippleStyleService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotRippleStyleService,
    factory: DotRippleStyleService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotRippleStyleService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class DotRippleDirective {
  document;
  ripple = true;
  _host;
  _area;
  _selfOnClick = this.onMouseClick.bind(this);
  constructor(document, elementRef, style) {
    this.document = document;
    this._host = elementRef.nativeElement;
    this._area = $append(this._host, (span => {
      span.className = 'dot-ripple-area';
      return span;
    })(document.createElement('span')), (span => {
      span.className = 'dot-ripple-reposition';
      return span;
    })(document.createElement('span')));
    this.attach();
  }
  ngOnInit() {}
  onMouseClick(event) {
    const span = this.document.createElement('span');
    span.className = 'dot-ripple-instance';
    const {
      x,
      y
    } = getRelativeMousePosition(event);
    span.style.left = x + 'px';
    span.style.top = y + 'px';
    span.addEventListener('animationend', remove);
    // this._host.appendChild(span);
    this._area.appendChild(span);
  }
  attach() {
    const {
      _host
    } = this;
    _host.classList.add('dot-ripple', 'dot-ripple_js');
    _host.addEventListener('click', this._selfOnClick);
  }
  detach() {
    const {
      _host
    } = this;
    _host.classList.remove('dot-ripple');
    _host.removeEventListener('click', this._selfOnClick);
  }
  static ɵfac = function DotRippleDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotRippleDirective)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(DotRippleStyleService));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotRippleDirective,
    selectors: [["", "dotRipple", ""]],
    inputs: {
      ripple: "ripple"
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotRippleDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[dotRipple]'
    }]
  }], () => [{
    type: Document,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i0.ElementRef
  }, {
    type: DotRippleStyleService
  }], {
    ripple: [{
      type: Input
    }]
  });
})();
function getRelativeMousePosition(event, target) {
  const rect = (target || event.target).getBoundingClientRect();
  return {
    x: event.clientX - rect.left,
    y: event.clientY - rect.top
  };
}
function remove() {
  this.parentNode.removeChild(this);
}

/**
 * Generated bundle index. Do not edit.
 */

export { DotRippleDirective, DotRippleStyleComponent, DotRippleStyleService };
